module.exports = __webpack_public_path__ + "fonts/3107C8_6_0.3106d32.woff";